import { useQueryClient } from "@tanstack/react-query";
import { useFetchData } from "@hooks/useFetchData";
import { useMutationData } from "@hooks/useMutationData";
import queryKeys from "@configs/react-query/query-key";
import {
  clearAwaitingUpdateSummary,
  isRecoveringUpdateSummary,
} from "@utils/updateSummarySession";

const SUMMARY_POLL_MS = 4000;

const useUpdateSummary = (enabled = false) => {
  const queryClient = useQueryClient();

  const query = useFetchData(
    [queryKeys.getUpdateSummary],
    queryKeys.getUpdateSummary,
    {
      method: "GET",
      skipErrorToast: true,
    },
    {},
    {
      enabled,
      retry: false,
      refetchOnWindowFocus: false,
      staleTime: Infinity,
      // Tab reloaded mid-update: poll until the host writes the summary file.
      refetchInterval: (summaryQuery) => {
        if (summaryQuery.state.data?.final_status || !isRecoveringUpdateSummary()) {
          return false;
        }
        return SUMMARY_POLL_MS;
      },
    }
  );

  const { mutate: acknowledgeUpdateSummary } = useMutationData(
    queryKeys.acknowledgeUpdateSummary,
    {
      method: "POST",
      skipErrorToast: true,
    },
    {
      onSuccess: () => {
        clearAwaitingUpdateSummary();
        queryClient.setQueryData([queryKeys.getUpdateSummary], null);
      },
    }
  );

  return { ...query, acknowledgeUpdateSummary };
};

export default useUpdateSummary;
